import { useQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { IStandardsSetsFetchResponse } from "@/search/Langston/types/IStandardsSetsFetchResponse";

interface StandardsSetFetchProps {
  options?: Omit<
    Parameters<typeof useQuery<IStandardsSetsFetchResponse[]>>,
    "queryKey" | "queryFn"
  >;
}

export const useFetchStandardsSets = ({ options }: StandardsSetFetchProps) => {
  return useQuery<IStandardsSetsFetchResponse[], Error>({
    ...options,
    queryKey: [ApiCatalog.contentDelivery.key],
    queryFn: async () => {
      const response = await api().get<IStandardsSetsFetchResponse[]>(
        ApiCatalog.contentDelivery.endpoint,
        {
          queryParams: {
            content_type: "STANDARD_SET",
            viewmodel_type: "list_type",
            ugc_only: "True",
          },
        },
      );
      return response;
    },
  });
};
